import {styled} from "@mui/system";
import Box from "@mui/material/Box";

const CustomTitleContainer = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '15px',
    marginBottom: '.5rem',
}));

export default CustomTitleContainer;
